export enum LibratoChartIds {
  CLIENT_LATENCY_JITTER = 8549179,
  INGEST_CLOCK_OFFSET = 3947240,
  MACHINE_CPU = 22937938,
  MACHINE_DISK = 22937972,
  MACHINE_MEM = 22937957,
  MIXER_BITRATES = 563162,
  MIXER_BUFFERS = 563492,
  SRT_BITRATE = 23237787,
  SRT_ROUDNTRIP = 23237957
}
